import AccountCard from "../../components/AccountCard";
import BottomRoundButton from "../../components/BottomRoundButton";
import Header from "../../components/Header";
import HorizontalCategoryItem from "../../components/HorizontalCategoryItem";
import HorizontalCategoryList from "../../components/HorizontalCategoryList";
import HorizontalShopList from "../../components/HorizontalShopList";
import MenuHeader from "../../components/MenuHeader";

export default function Home() {
    return (<>
        <Header />

        <AccountCard />

        <MenuHeader title="آخرین فروشگاه ها" />
        <HorizontalShopList />

        <MenuHeader title="دسته بندی ها" />
        <HorizontalCategoryList />

        <MenuHeader title="محبوب شما" />
        <HorizontalShopList />

        <BottomRoundButton />
    </>)
}